import { Component, ContentChild, forwardRef, Input, TemplateRef } from '@angular/core';
import { DestroySubscribers } from '../../../../decorators/destroy-subscribers.decorator';
import { FormWithHintAbstract } from '../abstract/form-with-hint.component';
import { TemplateDirective } from '@platform500services/p500-ui-kit';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gtd-select-with-hint',
  templateUrl: './select-with-hint.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SelectWithHintComponent),
    },
  ],
})
@DestroySubscribers()
export class SelectWithHintComponent extends FormWithHintAbstract {
  @ContentChild(TemplateDirective, { read: TemplateRef }) public template: TemplateRef<any>;
  @Input() public data: { [key: string]: any };
  @Input() clearable: boolean;
  @Input() public bindLabel: string;
  @Input() public bindValue: string;
  @Input() public multiple = false;
  @Input() public placeholder: string = 'Select data...';
  @Input() public required: boolean;
}
